import thumbnail from './stackedbarchart_thumb.svg';

export const metadata = {
  name: 'global.section.chartselection.stackedbarchart.title',
  id: 'stackedbar',
  thumbnail,
  icon: 'fa-chart-column',
  categories: ['categories.correlations', 'categories.proportions'],
  description: 'global.section.chartselection.stackedbarchart.description',
  code: '',
  tutorial: '',
};
